import ResumePage from './ResumePage'

export default ResumePage
